import { render, staticRenderFns } from "./NewsInformation.vue?vue&type=template&id=371b8ffa&scoped=true"
import script from "./NewsInformation.vue?vue&type=script&lang=js"
export * from "./NewsInformation.vue?vue&type=script&lang=js"
import style0 from "./NewsInformation.vue?vue&type=style&index=0&id=371b8ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371b8ffa",
  null
  
)

export default component.exports